import { SET_ENTITY } from "@/store/mutation-types";

const initialState = () => {
  let user= null
  const lsUser = localStorage.getItem('currentUser');
  if (lsUser != null) {
    user= JSON.parse(lsUser)
  }
  return {
    user: user,
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async login({ dispatch }, credentials) {
      const data = await this.$api.auth.login(credentials);
      this.$jwt.saveToken(data.token);
      this.$api.auth.setAuthHeader();
      dispatch("getMe");
    },
    async logout({ commit }, sendRequest = false) {
      if (sendRequest) {
        await this.$api.auth.logout();
      }
      this.$jwt.destroyToken();
      this.$api.auth.setAuthHeader();
      commit(
        SET_ENTITY,
        { module: "Auth", entity: "user", value: null },
        { root: true }
      );
      localStorage.removeItem('currentUser');
      
    },

    async getMe({ commit, dispatch }){
      try {
        const data = await this.$api.auth.getMe();
        // TODO: сделать как-то элегантнее
        if (data == 0) { 
          dispatch("logout", false);
          return false
        }
        
        commit(
          SET_ENTITY,
          { module: "Auth", entity: "user", value: data },
          { root: true }
        );
        localStorage.setItem('currentUser', JSON.stringify(data));
      } catch {
        // Note: in case of not proper login, i.e. token is expired
        dispatch("logout", false);
        return false
      }
      return true
    },
  },
};